export default __webpack_public_path__ + "static/media/login-popup-back.dc35285a.svg";